const DEPENDENT_TYPES = ["D-Dependent", "Not Eligible"];

export default DEPENDENT_TYPES;
